import "../print.scss";
const PrintAdmin = () => {
  return (
    <div className="print-admin">
      <header>
        <div className="date">
          Obračun:
          <span className="month">Maj</span>
          <span className="year">2021</span>
        </div>
      </header>
      <main>
        <article>
          <div>
            <div className="name">Miroljub Tomašević</div>
            <div className="position">Generalni direktor</div>
          </div>
          <div>
            <div className="print-grid">
              <div className="row header">
                <div className="col strong">Broj sati</div>
                <div className="col strong">Din/Sat</div>
                <div className="col strong">Zaradio</div>
                <div className="col strong">Na račun</div>
                <div className="col strong">Obračun</div>
                <div className="col strong">Datum isplate</div>
                <div className="col strong">Bonus</div>
                <div className="col strong">Troškovi</div>
              </div>
              <div className="row">
                <div className="col">
                  <div></div>
                </div>
                <div className="col">
                  <div></div>
                </div>
                <div className="col strong price-blue">
                  <div>80.000 RSD</div>
                </div>
                <div className="col strong price-blue">
                  <div>80.000 RSD</div>
                </div>
                <div className="col strong price-green">
                  <div>0 RSD</div>
                </div>
                <div className="col">
                  <div>16.4.2021.</div>
                </div>
                <div className="col">
                  <div>100.000 RSD</div>
                </div>
                <div className="col">
                  <div></div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div></div>
                </div>
                <div className="col">
                  <div></div>
                </div>
                <div className="col blank">
                  <div></div>
                </div>
                <div className="col blank">
                  <div></div>
                </div>
                <div className="col blank">
                  <div></div>
                </div>
                <div className="col blank">
                  <div></div>
                </div>
                <div className="col blank">
                  <div></div>
                </div>
                <div className="col blank">
                  <div></div>
                </div>
              </div>
              <div className="row header sub-row additional-space">
                <div className="col strong">Obroci</div>
                <div className="col strong">Keš obroci</div>
                <div className="col strong">Dana bolovanja</div>
                <div className="col strong">Dana odmora</div>
              </div>
              <div className="row sub-row">
                <div className="col">
                  <div></div>
                </div>
                <div className="col">
                  <div></div>
                </div>
                <div className="col">
                  <div></div>
                </div>
                <div className="col">
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </article>
      </main>
      <footer>
        <div>
          Ukupno: <span>20</span>
        </div>
      </footer>
    </div>
  );
};

export default PrintAdmin;
